import axios from 'axios'

interface CatchErrorLoginProps {
  logged: boolean
  message: string
}

export function catchErrorLogin(error: unknown): CatchErrorLoginProps {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status
    // Regra de negocio do backend (ex.: usuario sem organizacao ativa vinculada)
    // vem como [{ msgUsuario, msgDesenvolvedor }] no corpo do 400.
    const data = error.response?.data as
      | Array<{ msgUsuario?: string }>
      | undefined
    const msgBackend =
      Array.isArray(data) && data[0]?.msgUsuario ? data[0].msgUsuario : ''

    if (status === 401) {
      return { logged: false, message: 'Usuário ou senha incorreta.' }
    }
    if (status === 400 && msgBackend) {
      return { logged: false, message: msgBackend }
    }
    if (status === 403) {
      return { logged: false, message: msgBackend || 'Operação ilegal.' }
    }
    if (status === 404) {
      return { logged: false, message: 'Usuário não encontrado.' }
    }
  }
  return { logged: false, message: 'Algo deu errado' }
}
